import {
  styled,
  Flex,
  $white,
  $fontWeightBold,
  $fontWeightLight
} from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Container = styled(Flex)`
  flex-direction: column;
  width: max-content;
`;

export const StepContainer = styled(Flex)`
  width: 90%;
  gap: 1rem;
  align-items: center;
  padding: 1rem;
  ${(props: { highlight: any }) =>
    props.highlight &&
    `
  border-radius: 12px;
  background: #EFE9FB;
  `}
`;

export const StepCount = styled(Flex)`
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 14px;
  line-height: 15px;
  background-color: ${(props: { highlight: any }) =>
    props?.highlight ? "#7C47E1" : "#E7E7F0"};
  color: ${(props: { highlight: any }) =>
    props?.highlight ? $white : "#5B5675"};
`;

export const StepName = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${(props: { highlight: any }) =>
    props?.highlight ? $fontWeightBold : $fontWeightLight};
  color: ${(props: { highlight: any }) =>
    props?.highlight ? "#040222" : "#5B5675"};
`;
